import { create } from 'zustand';
import type { DrawMode } from '../hooks/useDrawing.js';

// Module-level singleton — one MapboxDraw instance shared across all useDrawing() calls
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _globalDraw: any | null = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setGlobalDraw = (d: any | null) => { _globalDraw = d; };
export const getGlobalDraw = () => _globalDraw;

interface DrawingState {
  mode: DrawMode;
  pendingFeatures: GeoJSON.Feature[];
  setMode: (m: DrawMode) => void;
  addFeatures: (fs: GeoJSON.Feature[]) => void;
  updateFeatures: (fs: GeoJSON.Feature[]) => void;
  removeFeatures: (ids: Set<string | number>) => void;
  clearFeatures: () => void;
}

export const useDrawingStore = create<DrawingState>((set) => ({
  mode: 'simple_select',
  pendingFeatures: [],
  setMode: (mode) => set({ mode }),
  addFeatures: (fs) => set((s) => ({ pendingFeatures: [...s.pendingFeatures, ...fs] })),
  updateFeatures: (fs) => set((s) => ({
    pendingFeatures: s.pendingFeatures.map(f => fs.find((u: GeoJSON.Feature) => u.id === f.id) ?? f),
  })),
  removeFeatures: (ids) => set((s) => ({
    pendingFeatures: s.pendingFeatures.filter(f => !ids.has(f.id as string)),
  })),
  clearFeatures: () => set({ pendingFeatures: [] }),
}));
